import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { logout } from '../utils/auth';
import './DriverDetail.css';

const fetchOptions = { credentials: 'include', headers: { 'Content-Type': 'application/json' } };

const DriverDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [driver, setDriver] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDriver = useCallback(async () => {
    try {
      const response = await fetch(`/api/drivers/${id}`, fetchOptions);
      if (response.status === 401) { logout(); navigate('/login'); return; }
      if (!response.ok) {
        const data = await response.json();
        setError(data.error || 'Failed to load driver');
        return;
      }
      const data = await response.json();
      setDriver(data);
    } catch (err) {
      setError('Failed to load driver details');
    } finally {
      setLoading(false);
    }
  }, [id, navigate]);

  useEffect(() => {
    fetchDriver();
  }, [fetchDriver]);

  if (loading) return <div className="driver-detail"><p>Loading driver details...</p></div>;
  if (error) return <div className="driver-detail"><p>Error: {error}</p></div>;
  if (!driver) return null;

  return (
    <div className="driver-detail">
      <div className="driver-detail-header">
        <h1>🏁 Driver Detail</h1>
        <button className="nav-button" onClick={() => navigate(-1)}>
          ← Back
        </button>
      </div>

      <div className="driver-profile-card">
        <div className="driver-number-badge">
          <span className="number">{driver.number}</span>
          <span className="label">Number</span>
        </div>
        <div className="driver-profile-info">
          <h2>{driver.name}</h2>
          <p className="driver-team-name">🏎️ {driver.team}</p>
          {driver.nationality && <p className="driver-nationality">🌍 {driver.nationality}</p>}
          <span className={`driver-status-badge ${driver.active ? 'driver-status-active' : 'driver-status-inactive'}`}>
            {driver.active ? 'Active' : 'Inactive'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DriverDetail;
